/* eslint-disable global-require */
import Vue from "vue";
import Vuex from "vuex";
import PersistedState from "vuex-persistedstate";

import queries from "./modules/queries";
import settings from "./modules/settings";
import auth from "./modules/auth";
import vault from "./modules/vault";

let modules = { queries, settings, auth, vault };

Vue.use(Vuex);

let plugins = [
	PersistedState({
		key: "settings",
		paths: ["settings"],
		storage: window.localStorage,
	}),
	PersistedState({
		key: "vault",
		paths: ["vault"],
		storage: window.localStorage,
	}),
	PersistedState({
		key: "queries",
		paths: ["queries"],
		storage: window.localStorage,
	}),
	PersistedState({
		// TODO: Indexed DB
		key: "gestios-info",
		paths: ["info"],
		storage: window.localStorage,
	}),
	PersistedState({
		key: "gestios-app",
		paths: ["apps"],
		storage: window.localStorage,
	}),
	PersistedState({
		key: "gestios-items",
		paths: ["items"],
		storage: window.localStorage,
	}),
	PersistedState({
		key: "gestios-data",
		paths: ["media", "emails", "avatars"],
		storage: window.localStorage,
	}),
	PersistedState({
		key: "gestios-config",
		paths: ["config"],
		storage: window.localStorage,
	}),
	PersistedState({
		key: "gestios-users",
		paths: ["auth", "users", "roles", "groups"],
		storage: window.localStorage,
	}),
];

try {
	const appModules = require("@/application/store/index");
	const appPlugins = appModules.default.plugins.map((p) => PersistedState(p));

	plugins = plugins.concat(appPlugins);
	modules = { ...appModules.default.modules, ...modules };
} catch (e) {
	if (process.env !== "production")
		console.warn("No se ha encontrado ningún módulo vuex personalizado");
}

export default new Vuex.Store({
	modules,
	plugins,
	strict: process.env.VUE_APP_ENVIRONMENT !== "production",
});
